module.exports = __webpack_public_path__ + "img/p2-18.4e44fde1.png";